import queries from "../helpers/caseQueries";
import Modal from "../Components/modal";

import React, { useState, useMemo, useEffect, useCallback } from "react";
import Select from "react-select";
import { useForm, Controller } from "react-hook-form";
import { FiEdit, FiTrash2 } from "react-icons/fi";

import { useQuery, useMutation } from "@apollo/react-hooks";
import { withUser } from "../Contexts/user";
import { useApolloClient } from "@apollo/react-hooks";
import userQueries from "../helpers/queries";
import AsyncSelect from "react-select/async";
import { useSidebar } from "../Contexts/sidebar";

const methodOptions = [
    { value: "monthly", label: "Monthly" },
    { value: "quarterly", label: "Quarterly" },
    { value: "halfyearly", label: "Half Yearly" },
    { value: "yearly", label: "Yearly" },
];

const planOptions = [
    { value: "ul", label: "Unit Linked" },
    { value: "tl", label: "Traditional" }
];

const NumberFormatter = new Intl.NumberFormat("en-GB", {
    minimumFractionDigits: 4,
    maximumFractionDigits: 4,
});

const statusOptions = [
    {
        label: "Pending",
        value: "pending",
    },
    {
        label: "Paid",
        value: "paid",
    },
];

let timerId;

const capitalizeWords = (str) => {
    return str.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase());
};

const Commissions = ({ user }) => {
    const apollo = useApolloClient();
    const { isDarkMode } = useSidebar();
    const [modalData, setModalData] = useState({});
    const [editModalState, setEditModalState] = useState(false);
    const [paginationState, setPaginationState] = useState({
        page: 1,
        pageSize: 30,
        totalPages: 0,
    });

    const initialFilters = useMemo(
        () => ({
            amount: undefined,
            term: undefined,
            status: undefined,
            dateFrom: undefined,
            dateTo: undefined,
            ...(user.auth.type === "user" && {
                mdgAgent: user.auth.userId,
            }),
            ...(user.auth.type === "pd" && {
                projectDirector: user.auth.userId,
            }),
            ...(user.auth.type === "sd" && {
                salesDirector: user.auth.userId,
            }),
            ...(user.auth.type === "agent" && {
                propertyAgent: user.auth.userId,
            }),
            ...(user.auth.type === "shareholder" && {
                shareholder: user.auth.userId,
            }),
            borrower: undefined,
            agency:
                user.auth.type === "admin"
                    ? "6871c77aca89ac1a1f353d32"
                    : undefined,
            inforceFrom: undefined,
            inforceTo: undefined,
            submissionFrom: undefined,
            submissionTo: undefined,
        }),
        [user.auth.type, user.auth.userId]
    );
    const [filters, setFilters] = useState(initialFilters);

    const [formKey, setFormKey] = useState(0);

    // Applied search variables - only updated when Search is clicked
    const initialAppliedSearchVariables = useMemo(
        () => ({
            amount: undefined,
            term: undefined,
            status: undefined,
            type: undefined,
            dateFrom: undefined,
            dateTo: undefined,
            projectDirector:
                user.auth.type === "pd" ? user.auth.userId : undefined,
            salesDirector:
                user.auth.type === "sd" ? user.auth.userId : undefined,
            shareholder:
                user.auth.type === "shareholder"
                    ? user.auth.userId
                    : undefined,
            propertyAgent:
                user.auth.type === "agent" ? user.auth.userId : undefined,
            borrower: undefined,
            agency:
                user.auth.type === "admin"
                    ? "6871c77aca89ac1a1f353d32"
                    : undefined,
            inforceFrom: undefined,
            inforceTo: undefined,
            submissionFrom: undefined,
            submissionTo: undefined,
            policyNumber: undefined,
        }),
        [user.auth.type, user.auth.userId]
    );
    const [appliedSearchVariables, setAppliedSearchVariables] = useState(
        initialAppliedSearchVariables
    );

    const handleSearch = () => {
        setAppliedSearchVariables({
            amount: filters.amount,
            term: filters.term,
            status: filters.status === "all" ? undefined : filters.status,
            type: filters.type,
            projectDirector: filters.projectDirector,
            salesDirector: filters.salesDirector,
            shareholder: filters.shareholder,
            propertyAgent: filters.propertyAgent,
            borrower: filters.borrower,
            dateFrom: filters.dateFrom,
            dateTo: filters.dateTo,
            agency: filters.agency,
            inforceFrom: filters.inforceFrom,
            inforceTo: filters.inforceTo,
            submissionFrom: filters.submissionFrom,
            submissionTo: filters.submissionTo,
            policyNumber: filters.policyNumber,
        });
        setPaginationState((prev) => ({ ...prev, page: 1 }));
    };

    const {
        errors,
        handleSubmit,
        control,
        setValue,
        reset: resetForm,
    } = useForm({
        defaultValues: {
            amount: "",
            term: undefined,
            status: undefined,
            projectDirector: undefined,
            salesDirector: undefined,
            shareholder: undefined,
            propertyAgent: undefined,
            borrower: undefined,
            agency: undefined,
        },
    });

    useEffect(() => {
        if (editModalState) {
            const { amount, term, status } = modalData;

            setValue("amount", amount);
            setValue(
                "term",
                term
                    ? {
                          label: term.name,
                          value: term._id,
                      }
                    : undefined
            );
            setValue("status", status);
        }
    }, [editModalState, modalData, setValue]);

    const {
        data: commissionsData,
        refetch: refetchCommissions,
        loading: commissionsLoading,
    } = useQuery(queries.FETCH_COMMISSIONS, {
        fetchPolicy: "network-only",
        variables: {
            limit: paginationState.pageSize,
            page: paginationState.page,
            amount: appliedSearchVariables.amount,
            term: appliedSearchVariables.term,
            status: appliedSearchVariables.status,
            type: appliedSearchVariables.type,
            projectDirector: appliedSearchVariables.projectDirector,
            salesDirector: appliedSearchVariables.salesDirector,
            shareholder: appliedSearchVariables.shareholder,
            propertyAgent: appliedSearchVariables.propertyAgent,
            borrower: appliedSearchVariables.borrower,
            dateFrom: appliedSearchVariables.dateFrom,
            dateTo: appliedSearchVariables.dateTo,
            policyNumber: appliedSearchVariables.policyNumber,
            agency: appliedSearchVariables.agency,
            inforceFrom: appliedSearchVariables.inforceFrom,
            inforceTo: appliedSearchVariables.inforceTo,
            submissionFrom: appliedSearchVariables.submissionFrom,
            submissionTo: appliedSearchVariables.submissionTo,
        },
        onError: ({ graphQLErrors, networkError }) => {
            if (graphQLErrors) {
                for (const graphQLError of graphQLErrors) {
                    console.log(graphQLError);
                }
            }

            if (networkError) {
                console.log(networkError);
            }
        },
    });

    const memberSelect = useMemo(
        () => ({
            control: (provided, state) => ({
                ...provided,
                borderColor: errors.area
                    ? "#fc8181"
                    : isDarkMode
                    ? "#4B5563"
                    : "#e2e8f0",
                backgroundColor: isDarkMode ? "#374151" : "#fbfdfe",
                borderRadius: "0.5rem",
                padding: "0.20rem",
                "&:hover": {
                    borderColor: errors.area
                        ? "#fc8181"
                        : isDarkMode
                        ? "#4B5563"
                        : "#e2e8f0",
                },
            }),

            placeholder: (provided, state) => ({
                ...provided,
                color: isDarkMode ? "#9CA3AF" : "#a0aec0",
                fontSize: "0.75rem",
                fontWeight: "600",
            }),

            container: (provided, state) => ({
                ...provided,
                color: isDarkMode ? "#D1D5DB" : "#64748b",
                fontSize: "0.75rem",
                fontWeight: "600",
                width: "100%",
            }),

            menu: (provided, state) => ({
                ...provided,
                backgroundColor: isDarkMode ? "#374151" : "#ffffff",
                borderColor: isDarkMode ? "#4B5563" : "#e2e8f0",
            }),

            option: (provided, state) => ({
                ...provided,
                backgroundColor: state.isSelected
                    ? isDarkMode
                        ? "#1F2937"
                        : "#3B82F6"
                    : state.isFocused
                    ? isDarkMode
                        ? "#4B5563"
                        : "#F3F4F6"
                    : isDarkMode
                    ? "#374151"
                    : "#ffffff",
                color: state.isSelected
                    ? isDarkMode
                        ? "#D1D5DB"
                        : "#ffffff"
                    : isDarkMode
                    ? "#D1D5DB"
                    : "#1F2937",
                "&:hover": {
                    backgroundColor: isDarkMode ? "#4B5563" : "#F3F4F6",
                    color: isDarkMode ? "#D1D5DB" : "#1F2937",
                },
            }),

            singleValue: (provided, state) => ({
                ...provided,
                color: isDarkMode ? "#D1D5DB" : "#1F2937",
            }),
        }),
        [errors, isDarkMode]
    );

    const [updateCommission] = useMutation(queries.UPDATE_COMMISSION);
    const [deleteCommission] = useMutation(queries.DELETE_COMMISSION);

    const handleEditCommission = async (formData) => {
        try {
            const result = await updateCommission({
                variables: {
                    input: {
                        _id: modalData._id,
                        amount: formData.amount,
                        term: formData.term,
                        status: formData.status.value,
                    },
                },
            });

            if (result.data) {
                refetchCommissions();
                setEditModalState(false);
                setModalData({});
                resetForm();
                alert("Commission updated successfully");
            }
        } catch (err) {
            alert("Failed to update commission");
            console.log(err);
        }
    };

    const handleDeleteCommission = async (commissionId) => {
        if (
            !window.confirm("Are you sure you want to delete this commission?")
        ) {
            return;
        }

        try {
            const result = await deleteCommission({
                variables: {
                    input: {
                        _id: commissionId,
                    },
                },
            });

            if (result.data) {
                refetchCommissions();
                alert("Commission deleted successfully");
            }
        } catch (err) {
            alert("Failed to delete commission");
            console.error(err);
        }
    };

    const loadSalesDirectors = useCallback(
        (val, callback) => {
            clearTimeout(timerId);
            timerId = setTimeout(async () => {
                const result = await apollo.query({
                    query: userQueries.FETCH_USERS,
                    variables: {
                        name: val,
                        limit: 9999,
                        page: 1,
                        type: "sd",
                    },
                    fetchPolicy: "network-only",
                });

                callback([
                    { label: "None", value: undefined },
                    ...result.data.fetchUsers.data.map((item) => ({
                        label: `${item.name}`,
                        value: item._id,
                    })),
                ]);
            }, 500);
        },
        [apollo]
    );

    const loadPropertyAgents = useCallback(
        (val, callback) => {
            clearTimeout(timerId);
            timerId = setTimeout(async () => {
                const result = await apollo.query({
                    query: userQueries.FETCH_USERS,
                    variables: {
                        name: val,
                        limit: 9999,
                        page: 1,
                        type: "agent",
                    },
                    fetchPolicy: "network-only",
                });

                callback([
                    { label: "None", value: undefined },
                    ...result.data.fetchUsers.data.map((item) => ({
                        label: `${item.name}`,
                        value: item._id,
                    })),
                ]);
            }, 500);
        },
        [apollo]
    );

    const loadProjectDirectors = useCallback(
        (val, callback) => {
            clearTimeout(timerId);
            timerId = setTimeout(async () => {
                const result = await apollo.query({
                    query: userQueries.FETCH_USERS,
                    variables: {
                        name: val,
                        limit: 9999,
                        page: 1,
                        type: "pd",
                    },
                    fetchPolicy: "network-only",
                });

                callback([
                    { label: "None", value: undefined },
                    ...result.data.fetchUsers.data.map((item) => ({
                        label: `${item.name}`,
                        value: item._id,
                    })),
                ]);
            }, 500);
        },
        [apollo]
    );

    const loadShareholders = useCallback(
        (val, callback) => {
            clearTimeout(timerId);
            timerId = setTimeout(async () => {
                const result = await apollo.query({
                    query: userQueries.FETCH_USERS,
                    variables: {
                        name: val,
                        limit: 9999,
                        page: 1,
                        type: "shareholder",
                    },
                    fetchPolicy: "network-only",
                });

                callback([
                    { label: "None", value: undefined },
                    ...result.data.fetchUsers.data.map((item) => ({
                        label: `${item.name}`,
                        value: item._id,
                    })),
                ]);
            }, 500);
        },
        [apollo]
    );

    const loadAgencies = useCallback(
        (val, callback) => {
            clearTimeout(timerId);
            timerId = setTimeout(async () => {
                const result = await apollo.query({
                    query: queries.FETCH_AGENCIES,
                    variables: {
                        name: val,
                        limit: 9999,
                        page: 1,
                        pagination: {
                            limit: 9999,
                            page: 1,
                        },
                    },
                    fetchPolicy: "network-only",
                });

                callback([
                    { label: "None", value: undefined },
                    ...result.data.fetchAgencies.data.map((item) => ({
                        label: `${item.name}`,
                        value: item._id,
                    })),
                ]);
            }, 500);
        },
        [apollo]
    );

    const handleBorrowerSearch = useCallback((value) => {
        clearTimeout(timerId);
        timerId = setTimeout(() => {
            setFilters((prev) => ({
                ...prev,
                borrower: value || undefined,
            }));
        }, 500);
    }, []);

    const handlePolicyNumberSearch = useCallback((value) => {
        clearTimeout(timerId);
        timerId = setTimeout(() => {
            setFilters((prev) => ({
                ...prev,
                policyNumber: value || undefined,
            }));
        }, 500);
    }, []);

    const handlePropertyAgentSearch = useCallback((value) => {
        clearTimeout(timerId);
        timerId = setTimeout(() => {
            setFilters((prev) => ({
                ...prev,
                propertyAgent: value || undefined,
            }));
        }, 500);
    }, []);

    // Calculate totals from frontend data as fallback
    const calculateTotalsFromData = (commissionsData) => {
        if (!commissionsData || !commissionsData.data || commissionsData.data.length === 0) {
            return { count: 0, amount: 0, termAmount: 0, totalTerms: 0 };
        }

        const uniqueActiveTerms = new Map();
        const totals = commissionsData.data.reduce((acc, commission) => {
            acc.count += 1;
            if (
                commission.type !== "bonus" &&
                commission.type !== "coordinator"
            ) {
                acc.amount += commission.amount || 0;
            }
            if (
                commission.term &&
                commission.term.status === "active" &&
                !uniqueActiveTerms.has(commission.term._id)
            ) {
                uniqueActiveTerms.set(commission.term._id, commission.term.amount || 0);
            }
            return acc;
        }, { count: 0, amount: 0, termAmount: 0, totalTerms: 0 });

        totals.totalTerms = uniqueActiveTerms.size;
        totals.termAmount = Array.from(uniqueActiveTerms.values()).reduce(
            (sum, amount) => sum + amount,
            0
        );

        return totals;
    };

    // Get totals - use backend totals if available and non-zero, otherwise calculate from data
    const getTotals = () => {
        const backendTotals = commissionsData?.fetchCommissions?.totals;
        const hasData = commissionsData?.fetchCommissions?.data?.length > 0;
        
        // If backend totals exist and have values, use them
        if (
            backendTotals &&
            (backendTotals.count > 0 ||
                backendTotals.amount > 0 ||
                backendTotals.termAmount > 0 ||
                backendTotals.totalTerms > 0)
        ) {
            return backendTotals;
        }
        
        // If we have data but no backend totals (or all zeros), calculate from frontend data
        if (hasData) {
            return calculateTotalsFromData(commissionsData.fetchCommissions);
        }
        
        // No data at all
        return { count: 0, amount: 0, termAmount: 0, totalTerms: 0 };
    };

    const resetEditModal = () => {
        setEditModalState(false);
        setModalData({});
        resetForm();
    };

    return (
        <div
            className={`min-h-screen w-full max-w-full overflow-x-hidden ${
                isDarkMode ? "bg-gray-900" : "bg-gray-50"
            }`}
        >
            <div className="px-4 py-8 w-full min-w-0 max-w-full">
                <div className="flex justify-between items-center mb-6">
                    <h1
                        className={`text-2xl font-bold ${
                            isDarkMode ? "text-white" : ""
                        }`}
                    >
                        Commissions
                    </h1>
                </div>

                <div
                    className={`${
                        isDarkMode ? "bg-gray-800 border-gray-700" : "bg-white"
                    } rounded-lg shadow p-4 mb-6 border`}
                    key={formKey}
                >
                    <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
                        <>
                            <div>
                                <label
                                    className={`block text-sm font-medium mb-1 ${
                                        isDarkMode
                                            ? "text-gray-300"
                                            : "text-gray-700"
                                    }`}
                                >
                                    Inforce Date
                                </label>
                                <div className="relative">
                                    <input
                                        className={`w-full py-2 px-3 rounded-lg border text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 ${
                                            isDarkMode
                                                ? "bg-gray-700 border-gray-600 text-white placeholder-gray-400"
                                                : "bg-white border-gray-300 text-gray-900"
                                        }`}
                                        type="text"
                                        placeholder="Select date range"
                                        value={`${
                                            filters.inforceFrom || ""
                                        } - ${filters.inforceTo || ""}`}
                                        onClick={(e) => {
                                            const calendar =
                                                e.target.nextElementSibling;
                                            if (calendar) {
                                                calendar.style.display =
                                                    calendar.style.display ===
                                                    "none"
                                                        ? "block"
                                                        : "none";
                                            }
                                        }}
                                    />
                                    <div
                                        className={`absolute z-10 mt-1 w-full rounded-lg shadow-lg border ${
                                            isDarkMode
                                                ? "bg-gray-800 border-gray-600"
                                                : "bg-white border-gray-200"
                                        }`}
                                        style={{ display: "none" }}
                                    >
                                        <div className="p-4">
                                            <div className="flex gap-4">
                                                <div>
                                                    <div
                                                        className={`text-sm font-medium mb-2 ${
                                                            isDarkMode
                                                                ? "text-gray-300"
                                                                : "text-gray-900"
                                                        }`}
                                                    >
                                                        From
                                                    </div>
                                                    <input
                                                        type="date"
                                                        className={`w-full py-1 px-2 border rounded ${
                                                            isDarkMode
                                                                ? "bg-gray-700 border-gray-600 text-white"
                                                                : "bg-white border-gray-300 text-gray-900"
                                                        }`}
                                                        value={
                                                            filters.inforceFrom ||
                                                            ""
                                                        }
                                                        onChange={(e) => {
                                                            const value =
                                                                e.target
                                                                    ?.value ||
                                                                "";
                                                            setFilters(
                                                                (prev) => ({
                                                                    ...prev,
                                                                    inforceFrom:
                                                                        value,
                                                                })
                                                            );
                                                        }}
                                                    />
                                                </div>
                                                <div>
                                                    <div
                                                        className={`text-sm font-medium mb-2 ${
                                                            isDarkMode
                                                                ? "text-gray-300"
                                                                : "text-gray-900"
                                                        }`}
                                                    >
                                                        To
                                                    </div>
                                                    <input
                                                        type="date"
                                                        className={`w-full py-1 px-2 border rounded ${
                                                            isDarkMode
                                                                ? "bg-gray-700 border-gray-600 text-white"
                                                                : "bg-white border-gray-300 text-gray-900"
                                                        }`}
                                                        value={
                                                            filters.inforceTo ||
                                                            ""
                                                        }
                                                        onChange={(e) => {
                                                            const value =
                                                                e.target
                                                                    ?.value ||
                                                                "";
                                                            setFilters(
                                                                (prev) => ({
                                                                    ...prev,
                                                                    inforceTo:
                                                                        value,
                                                                })
                                                            );
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                            <div className="flex justify-end gap-2 mt-4">
                                                <button
                                                    className={`px-3 py-1 text-sm rounded ${
                                                        isDarkMode
                                                            ? "bg-gray-700 hover:bg-gray-600 text-gray-300"
                                                            : "bg-gray-100 hover:bg-gray-200 text-gray-700"
                                                    }`}
                                                    onClick={(e) => {
                                                        setFilters((prev) => ({
                                                            ...prev,
                                                            inforceFrom:
                                                                undefined,
                                                            inforceTo:
                                                                undefined,
                                                        }));
                                                        e.target.closest(
                                                            ".absolute"
                                                        ).style.display =
                                                            "none";
                                                    }}
                                                >
                                                    Clear
                                                </button>
                                                <button
                                                    className="px-3 py-1 text-sm bg-orange-400 text-white hover:bg-orange-500 rounded"
                                                    onClick={(e) => {
                                                        e.target.closest(
                                                            ".absolute"
                                                        ).style.display =
                                                            "none";
                                                    }}
                                                >
                                                    Apply
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div>
                                <label
                                    className={`block text-sm font-medium mb-1 ${
                                        isDarkMode
                                            ? "text-gray-300"
                                            : "text-gray-700"
                                    }`}
                                >
                                    Submission Date
                                </label>
                                <div className="relative">
                                    <input
                                        className={`w-full py-2 px-3 rounded-lg border text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 ${
                                            isDarkMode
                                                ? "bg-gray-700 border-gray-600 text-white placeholder-gray-400"
                                                : "bg-white border-gray-300 text-gray-900"
                                        }`}
                                        type="text"
                                        placeholder="Select date range"
                                        value={`${
                                            filters.submissionFrom || ""
                                        } - ${filters.submissionTo || ""}`}
                                        onClick={(e) => {
                                            const calendar =
                                                e.target.nextElementSibling;
                                            if (calendar) {
                                                calendar.style.display =
                                                    calendar.style.display ===
                                                    "none"
                                                        ? "block"
                                                        : "none";
                                            }
                                        }}
                                    />
                                    <div
                                        className={`absolute z-10 mt-1 w-full rounded-lg shadow-lg border ${
                                            isDarkMode
                                                ? "bg-gray-800 border-gray-600"
                                                : "bg-white border-gray-200"
                                        }`}
                                        style={{ display: "none" }}
                                    >
                                        <div className="p-4">
                                            <div className="flex gap-4">
                                                <div>
                                                    <div
                                                        className={`text-sm font-medium mb-2 ${
                                                            isDarkMode
                                                                ? "text-gray-300"
                                                                : "text-gray-900"
                                                        }`}
                                                    >
                                                        From
                                                    </div>
                                                    <input
                                                        type="date"
                                                        className={`w-full py-1 px-2 border rounded ${
                                                            isDarkMode
                                                                ? "bg-gray-700 border-gray-600 text-white"
                                                                : "bg-white border-gray-300 text-gray-900"
                                                        }`}
                                                        value={
                                                            filters.submissionFrom ||
                                                            ""
                                                        }
                                                        onChange={(e) => {
                                                            const value =
                                                                e.target
                                                                    ?.value ||
                                                                "";
                                                            setFilters(
                                                                (prev) => ({
                                                                    ...prev,
                                                                    submissionFrom:
                                                                        value,
                                                                })
                                                            );
                                                        }}
                                                    />
                                                </div>
                                                <div>
                                                    <div
                                                        className={`text-sm font-medium mb-2 ${
                                                            isDarkMode
                                                                ? "text-gray-300"
                                                                : "text-gray-900"
                                                        }`}
                                                    >
                                                        To
                                                    </div>
                                                    <input
                                                        type="date"
                                                        className={`w-full py-1 px-2 border rounded ${
                                                            isDarkMode
                                                                ? "bg-gray-700 border-gray-600 text-white"
                                                                : "bg-white border-gray-300 text-gray-900"
                                                        }`}
                                                        value={
                                                            filters.submissionTo ||
                                                            ""
                                                        }
                                                        onChange={(e) => {
                                                            const value =
                                                                e.target
                                                                    ?.value ||
                                                                "";
                                                            setFilters(
                                                                (prev) => ({
                                                                    ...prev,
                                                                    submissionTo:
                                                                        value,
                                                                })
                                                            );
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                            <div className="flex justify-end gap-2 mt-4">
                                                <button
                                                    className={`px-3 py-1 text-sm rounded ${
                                                        isDarkMode
                                                            ? "bg-gray-700 hover:bg-gray-600 text-gray-300"
                                                            : "bg-gray-100 hover:bg-gray-200 text-gray-700"
                                                    }`}
                                                    onClick={(e) => {
                                                        setFilters((prev) => ({
                                                            ...prev,
                                                            submissionFrom:
                                                                undefined,
                                                            submissionTo:
                                                                undefined,
                                                        }));
                                                        e.target.closest(
                                                            ".absolute"
                                                        ).style.display =
                                                            "none";
                                                    }}
                                                >
                                                    Clear
                                                </button>
                                                <button
                                                    className="px-3 py-1 text-sm bg-orange-400 text-white hover:bg-orange-500 rounded"
                                                    onClick={(e) => {
                                                        e.target.closest(
                                                            ".absolute"
                                                        ).style.display =
                                                            "none";
                                                    }}
                                                >
                                                    Apply
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {(!["pd", "sd", "agent", "shareholder", "admin"].includes(
                                user.auth.type
                            ) || user.auth.userId === "68d51ef17005923fc4038dab") && (
                                <div>
                                    <label
                                        className={`block text-sm font-medium mb-1 ${
                                            isDarkMode
                                                ? "text-gray-300"
                                                : "text-gray-700"
                                        }`}
                                    >
                                        Agency
                                    </label>
                                    <Controller
                                        as={AsyncSelect}
                                        name="agency"
                                        control={control}
                                        styles={memberSelect}
                                        isSearchable={true}
                                        placeholder="Select Agency"
                                        loadOptions={loadAgencies}
                                        isClearable={true}
                                        onChange={([selected]) => {
                                            setFilters((prev) => ({
                                                ...prev,
                                                agency: selected?.value,
                                            }));
                                            return selected;
                                        }}
                                    />
                                </div>
                            )}

                            <div>
                                <label
                                    className={`block text-sm font-medium mb-1 ${
                                        isDarkMode
                                            ? "text-gray-300"
                                            : "text-gray-700"
                                    }`}
                                >
                                    Borrower Name
                                </label>
                                <input
                                    id="borrower-search"
                                    type="text"
                                    className={`my-2 p-3 w-full rounded-lg block border font-semibold text-xs ${
                                        isDarkMode
                                            ? "bg-gray-700 border-gray-600 text-white placeholder-gray-400"
                                            : "bg-cool-gray border-gray-300 text-lynch"
                                    }`}
                                    placeholder="Search borrower name..."
                                    onChange={(e) =>
                                        handleBorrowerSearch(e.target.value)
                                    }
                                />
                            </div>

                            <div>
                                <label
                                    className={`block text-sm font-medium mb-1 ${
                                        isDarkMode
                                            ? "text-gray-300"
                                            : "text-gray-700"
                                    }`}
                                >
                                    Policy Number
                                </label>
                                <input
                                    id="policy-search"
                                    type="text"
                                    className={`my-2 p-3 w-full rounded-lg block border font-semibold text-xs ${
                                        isDarkMode
                                            ? "bg-gray-700 border-gray-600 text-white placeholder-gray-400"
                                            : "bg-cool-gray border-gray-300 text-lynch"
                                    }`}
                                    placeholder="Search policy number..."
                                    onChange={(e) =>
                                        handlePolicyNumberSearch(e.target.value)
                                    }
                                />
                            </div>

                            {(user.auth.type === "superadmin" || user.auth.type === "admin" || user.auth.type === "user") && (
                                <div>
                                    <label
                                        className={`block text-sm font-medium mb-1 ${
                                            isDarkMode
                                                ? "text-gray-300"
                                                : "text-gray-700"
                                        }`}
                                    >
                                        Type
                                    </label>
                                    <Controller
                                        as={Select}
                                        name="type"
                                        control={control}
                                        styles={memberSelect}
                                        isSearchable={false}
                                        placeholder="Select Type"
                                        options={user.auth.type === "user" ? [
                                            { label: "NFC Agent", value: "agent" },
                                            { label: "Property Agent", value: "bonus" },
                                        ] : [
                                            { label: "PD", value: "pd" },
                                            { label: "SD", value: "sd" },
                                            { label: "NFC Agent", value: "agent" },
                                            {
                                                label: "Shareholder",
                                                value: "dennis",
                                            },
                                            { label: "Property Agent", value: "bonus" },
                                            { label: "Coordinator", value: "coordinator" },
                                        ]}
                                        isClearable={true}
                                        onChange={([selected]) => {
                                            setFilters((prev) => ({
                                                ...prev,
                                                type: selected?.value,
                                            }));
                                            return selected;
                                        }}
                                    />
                                </div>
                            )}

                            {!["pd", "sd", "agent", "user"].includes(
                                user.auth.type
                            ) && (
                                <div>
                                    <label
                                        className={`block text-sm font-medium mb-1 ${
                                            isDarkMode
                                                ? "text-gray-300"
                                                : "text-gray-700"
                                        }`}
                                    >
                                        Project Director
                                    </label>
                                    <Controller
                                        as={AsyncSelect}
                                        name="projectDirector"
                                        control={control}
                                        styles={memberSelect}
                                        isSearchable={true}
                                        placeholder="Select Project Director"
                                        loadOptions={loadProjectDirectors}
                                        isClearable={true}
                                        onChange={([selected]) => {
                                            setFilters((prev) => ({
                                                ...prev,
                                                projectDirector:
                                                    selected?.value,
                                            }));
                                            return selected;
                                        }}
                                    />
                                </div>
                            )}

                            {!["pd", "sd", "agent", "user"].includes(
                                user.auth.type
                            ) && (
                                <div>
                                    <label
                                        className={`block text-sm font-medium mb-1 ${
                                            isDarkMode
                                                ? "text-gray-300"
                                                : "text-gray-700"
                                        }`}
                                    >
                                        Sales Director
                                    </label>
                                    <Controller
                                        as={AsyncSelect}
                                        name="salesDirector"
                                        control={control}
                                        styles={memberSelect}
                                        isSearchable={true}
                                        placeholder="Select Sales Director"
                                        loadOptions={loadSalesDirectors}
                                        isClearable={true}
                                        onChange={([selected]) => {
                                            setFilters((prev) => ({
                                                ...prev,
                                                salesDirector: selected?.value,
                                            }));
                                            return selected;
                                        }}
                                    />
                                </div>
                            )}

                            {!["pd", "sd", "agent", "user"].includes(
                                user.auth.type
                            ) && (
                                <div>
                                    <label
                                        className={`block text-sm font-medium mb-1 ${
                                            isDarkMode
                                                ? "text-gray-300"
                                                : "text-gray-700"
                                        }`}
                                    >
                                        Shareholder
                                    </label>
                                    <Controller
                                        as={AsyncSelect}
                                        name="shareholder"
                                        control={control}
                                        styles={memberSelect}
                                        isSearchable={true}
                                        placeholder="Select Shareholder"
                                        loadOptions={loadShareholders}
                                        isClearable={true}
                                        onChange={([selected]) => {
                                            setFilters((prev) => ({
                                                ...prev,
                                                shareholder: selected?.value,
                                            }));
                                            return selected;
                                        }}
                                    />
                                </div>
                            )}

                            {user.auth.type !== "agent" && (
                                <div>
                                    <label
                                        className={`block text-sm font-medium mb-1 ${
                                            isDarkMode
                                                ? "text-gray-300"
                                                : "text-gray-700"
                                        }`}
                                    >
                                        Property Agent
                                    </label>
                                    <input
                                        id="property-agent-search"
                                        type="text"
                                        className={`my-2 p-3 w-full rounded-lg block border font-semibold text-xs ${
                                            isDarkMode
                                                ? "bg-gray-700 border-gray-600 text-white placeholder-gray-400"
                                                : "bg-cool-gray border-gray-300 text-lynch"
                                        }`}
                                        placeholder="Search property agent..."
                                        onChange={(e) =>
                                            handlePropertyAgentSearch(e.target.value)
                                        }
                                    />
                                </div>
                            )}
                        </>

                        <div>
                            <label
                                className={`block text-sm font-medium mb-1 ${
                                    isDarkMode
                                        ? "text-gray-300"
                                        : "text-gray-700"
                                }`}
                            >
                                Status
                            </label>
                            <Controller
                                as={Select}
                                name="status"
                                control={control}
                                styles={memberSelect}
                                isSearchable={false}
                                placeholder="Select Status"
                                options={statusOptions}
                                isClearable={true}
                                onChange={([selected]) => {
                                    setFilters((prev) => ({
                                        ...prev,
                                        status: selected?.value,
                                    }));
                                    return selected;
                                }}
                            />
                        </div>
                        <div className="flex items-end gap-2 mb-4 flex-shrink-0">
                            <button
                                type="button"
                                onClick={handleSearch}
                                className={`px-4 py-2 rounded text-white ${
                                    isDarkMode
                                        ? "bg-blue-600 hover:bg-blue-500"
                                        : "bg-blue-500 hover:bg-blue-600"
                                }`}
                            >
                                Search
                            </button>
                            <button
                                onClick={() => {
                                    // Reset to base state, including role defaults
                                    setFilters(initialFilters);
                                    setAppliedSearchVariables(
                                        initialAppliedSearchVariables
                                    );
                                    setPaginationState((prev) => ({
                                        ...prev,
                                        page: 1,
                                    }));
                                    // Reset form fields
                                    resetForm();
                                    // Force re-render of form to clear dropdowns
                                    setFormKey((prev) => prev + 1);
                                    // Clear search input fields
                                    const borrowerInput =
                                        document.getElementById(
                                            "borrower-search"
                                        );
                                    const policyInput =
                                        document.getElementById(
                                            "policy-search"
                                        );
                                    const propertyAgentInput =
                                        document.getElementById(
                                            "property-agent-search"
                                        );
                                    if (borrowerInput) borrowerInput.value = "";
                                    if (policyInput) policyInput.value = "";
                                    if (propertyAgentInput) propertyAgentInput.value = "";
                                }}
                                className={`px-4 py-2 rounded text-white ${
                                    isDarkMode
                                        ? "bg-gray-600 hover:bg-gray-500"
                                        : "bg-gray-500 hover:bg-gray-600"
                                }`}
                            >
                                Reset Filters
                            </button>
                        </div>
                    </div>
                </div>

                {/* Totals Summary */}
                {commissionsData && commissionsData.fetchCommissions && (
                    <div className="mb-8">
                        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
                            <div
                                className={`bg-orange-400 rounded-xl shadow-xl p-8 transform `}
                            >
                                <div className="flex items-center justify-between">
                                    <div className="space-y-3">
                                        <div className="flex items-center space-x-2">
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                className="h-6 w-6 text-black"
                                                fill="none"
                                                viewBox="0 0 24 24"
                                                stroke="currentColor"
                                            >
                                                <path
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    strokeWidth={2}
                                                    d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"
                                                />
                                            </svg>
                                            <div className="text-orange-50 text-sm font-semibold uppercase tracking-wider">
                                                Total Records
                                            </div>
                                        </div>
                                        <div className="text-4xl font-bold">
                                            {getTotals().count}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div
                                className={`bg-orange-400 rounded-xl shadow-xl p-8 transform `}
                            >
                                <div className="flex items-center justify-between">
                                    <div className="space-y-3">
                                        <div className="flex items-center space-x-2">
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                className="h-6 w-6 text-black"
                                                fill="none"
                                                viewBox="0 0 24 24"
                                                stroke="currentColor"
                                            >
                                                <path
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    strokeWidth={2}
                                                    d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"
                                                />
                                            </svg>
                                            <div className="text-orange-50 text-sm font-semibold uppercase tracking-wider">
                                                Total Terms
                                            </div>
                                        </div>
                                        <div className="text-4xl font-bold">
                                            {getTotals().totalTerms}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div
                                className={`bg-orange-400 rounded-xl shadow-xl p-8 transform `}
                            >
                                <div className="flex items-center justify-between">
                                    <div className="space-y-3">
                                        <div className="flex items-center space-x-2">
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                className="h-6 w-6 text-black"
                                                fill="none"
                                                viewBox="0 0 24 24"
                                                stroke="currentColor"
                                            >
                                                <path
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    strokeWidth={2}
                                                    d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                                                />
                                            </svg>
                                            <div className="text-orange-50 text-sm font-semibold uppercase tracking-wider">
                                                Total Commission
                                            </div>
                                        </div>
                                        <div className="text-4xl font-bold">
                                            RM
                                            {NumberFormatter.format(
                                                getTotals().amount
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div
                                className={`bg-orange-400 rounded-xl shadow-xl p-8 transform `}
                            >
                                <div className="flex items-center justify-between">
                                    <div className="space-y-3">
                                        <div className="flex items-center space-x-2">
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                className="h-6 w-6 text-black"
                                                fill="none"
                                                viewBox="0 0 24 24"
                                                stroke="currentColor"
                                            >
                                                <path
                                                    strokeLinecap="round"
                                                    strokeLinejoin="round"
                                                    strokeWidth={2}
                                                    d="M9 7h6m0 10v-3m-3 3h.01M9 17h.01M9 14h.01M12 14h.01M15 11h.01M12 11h.01M9 11h.01M7 21h10a2 2 0 002-2V5a2 2 0 00-2-2H7a2 2 0 00-2 2v14a2 2 0 002 2z"
                                                />
                                            </svg>
                                            <div className="text-orange-50 text-sm font-semibold uppercase tracking-wider">
                                                Premium Amount
                                            </div>
                                        </div>
                                        <div className="text-4xl font-bold">
                                            RM
                                            {NumberFormatter.format(
                                                getTotals().termAmount
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                <div
                    className={`${
                        isDarkMode ? "bg-gray-800 border-gray-700" : "bg-white"
                    } rounded-lg shadow border overflow-x-auto w-full min-w-0 max-w-full`}
                >
                    {commissionsLoading ? (
                        <div className="flex flex-col items-center justify-center py-24 px-4">
                            <div className="relative w-16 h-16 mb-4">
                                <div className="absolute inset-0 border-4 border-orange-200 rounded-full"></div>
                                <div className="absolute inset-0 border-4 border-orange-500 rounded-full border-t-transparent animate-spin"></div>
                            </div>
                            <p className={`font-medium ${isDarkMode ? "text-gray-300" : "text-gray-600"}`}>
                                Loading commissions...
                            </p>
                            <p className={`text-sm mt-1 ${isDarkMode ? "text-gray-500" : "text-gray-400"}`}>
                                Please wait
                            </p>
                        </div>
                    ) : (
                    <>
                    <table className="min-w-full divide-y divide-gray-200">
                        <thead className={`text-black`}>
                            <tr className="bg-orange-400">
                                <th
                                    className={`px-6 py-3 text-left text-xs font-medium text-black uppercase tracking-wider`}
                                >
                                    Submission Date
                                </th>
                                <th
                                    className={`px-6 py-3 text-left text-xs font-medium text-black uppercase tracking-wider`}
                                >
                                    Inforce Date
                                </th>
                                <th
                                    className={`px-6 py-3 text-left text-xs font-medium text-black uppercase tracking-wider`}
                                >
                                    USER
                                </th>
                                <th
                                    className={`px-6 py-3 text-left text-xs font-medium text-black uppercase tracking-wider`}
                                >
                                    Agency
                                </th>
                                <th
                                    className={`px-6 py-3 text-left text-xs font-medium text-black uppercase tracking-wider`}
                                >
                                    Project
                                </th>
                                <th
                                    className={`px-6 py-3 text-left text-xs font-medium text-black uppercase tracking-wider`}
                                >
                                    Property Agent
                                </th>
                                <th
                                    className={`px-6 py-3 text-left text-xs font-medium text-black uppercase tracking-wider`}
                                >
                                    Unit Number
                                </th>
                                <th
                                    className={`px-6 py-3 text-left text-xs font-medium text-black uppercase tracking-wider`}
                                >
                                    Policy Number
                                </th>
                                <th
                                    className={`px-6 py-3 text-left text-xs font-medium text-black uppercase tracking-wider`}
                                >
                                    Borrower
                                </th>
                                <th
                                    className={`px-6 py-3 text-left text-xs font-medium text-black uppercase tracking-wider`}
                                >
                                    Amount
                                </th>
                                <th
                                    className={`px-6 py-3 text-left text-xs font-medium text-black uppercase tracking-wider`}
                                >
                                    Type
                                </th>
                                <th
                                    className={`px-6 py-3 text-left text-xs font-medium text-black uppercase tracking-wider`}
                                >
                                    Plan
                                </th>
                                <th
                                    className={`px-6 py-3 text-left text-xs font-medium text-black uppercase tracking-wider`}
                                >
                                    Payment Method
                                </th>
                                <th
                                    className={`px-6 py-3 text-left text-xs font-medium text-black uppercase tracking-wider`}
                                >
                                    Payment Term (Years)
                                </th>
                                <th
                                    className={`px-6 py-3 text-left text-xs font-medium text-black uppercase tracking-wider`}
                                >
                                    Premium Amount
                                </th>
                                <th
                                    className={`px-6 py-3 text-left text-xs font-medium text-black uppercase tracking-wider`}
                                >
                                    Status
                                </th>
                                {(user.auth.type === "superadmin" || user.auth.type === "admin" || user.auth.type === "manager") && (
                                    <th
                                        className={`px-6 py-3 text-left text-xs font-medium text-black uppercase tracking-wider`}
                                    >
                                        Actions
                                    </th>
                                )}
                            </tr>
                        </thead>
                        <tbody
                            className={`${
                                isDarkMode ? "bg-gray-800" : "bg-white"
                            } divide-y divide-gray-200`}
                        >
                            {commissionsData ? (
                                commissionsData.fetchCommissions.data.map(
                                    (commission) => {
                                        const borrower =
                                            commission.case?.borrower?.find(
                                                (b) =>
                                                    b._id ===
                                                    commission.term?.borrower
                                            ) || null;
                                        return (
                                            <tr
                                                key={commission._id}
                                                className={`${
                                                    isDarkMode
                                                        ? "text-white hover:bg-gray-700"
                                                        : "text-black hover:bg-gray-50"
                                                }`}
                                            >
                                                <td className="px-6 py-4">
                                                    {commission.term
                                                        ?.createdAt
                                                        ? new Date(
                                                              Number(
                                                                  commission
                                                                      .term
                                                                      .createdAt
                                                              )
                                                          )
                                                              .toISOString()
                                                              .split("T")[0]
                                                        : "-"}
                                                </td>
                                                <td className="px-6 py-4">
                                                    {commission.term
                                                        ?.inforceDate
                                                        ? new Date(
                                                              Number(
                                                                  commission
                                                                      .term
                                                                      .inforceDate
                                                              )
                                                          )
                                                              .toISOString()
                                                              .split("T")[0]
                                                        : "-"}
                                                </td>
                                                <td className="px-6 py-4">
                                                    {commission.user?.name
                                                        ? capitalizeWords(
                                                              commission.user
                                                                  .name
                                                          )
                                                        : "-"}
                                                </td>
                                                <td className="px-6 py-4">
                                                    {commission.case?.agency
                                                        ?.name || "-"}
                                                </td>
                                                <td className="px-6 py-4">
                                                    {commission.case?.project
                                                        ?.name || "-"}
                                                </td>
                                                <td className="px-6 py-4">
                                                    {commission.case
                                                        ?.propertyAgent
                                                        ? capitalizeWords(
                                                              commission.case
                                                                  .propertyAgent
                                                          )
                                                        : "-"}
                                                </td>
                                                <td className="px-6 py-4">
                                                    {commission.case
                                                        ?.unitNumber || "-"}
                                                </td>
                                                <td className="px-6 py-4">
                                                    {commission.term
                                                        ?.policyNumber || "-"}
                                                </td>
                                                <td className="px-6 py-4">
                                                    {borrower?.name || "-"}
                                                </td>
                                                <td className="px-6 py-4">
                                                    RM
                                                    {NumberFormatter.format(
                                                        commission.amount
                                                    )}
                                                </td>
                                                <td className="px-6 py-4">
                                                    {commission.type === "agent"
                                                        ? "NFC Agent"
                                                        : commission.type ===
                                                          "user"
                                                        ? "NFC Agent"
                                                        : commission.type ===
                                                          "pd"
                                                        ? "Project Director"
                                                        : commission.type ===
                                                          "sd"
                                                        ? "Sales Director"
                                                        : commission.type ===
                                                          "shareholder"
                                                        ? "Shareholder"
                                                        : commission.type ===
                                                          "admin"
                                                        ? "Admin"
                                                        : commission.type ===
                                                          "superadmin"
                                                        ? "Superadmin"
                                                        : commission.type === "bonus"
                                                        ? "Property Agent"
                                                        : commission.type === "coordinator"
                                                        ? "Coordinator"
                                                        : "Shareholder"}
                                                </td>
                                                <td className="px-6 py-4">
                                                    {commission.term?.plan
                                                        ? planOptions.find(
                                                              (p) =>
                                                                  p.value ===
                                                                  commission
                                                                      .term
                                                                      .plan
                                                          )?.label ||
                                                          commission.term.plan
                                                        : "-"}
                                                </td>
                                                <td className="px-6 py-4">
                                                    {commission.term?.method
                                                        ? methodOptions.find(
                                                              (m) =>
                                                                  m.value ===
                                                                  commission
                                                                      .term
                                                                      .method
                                                          )?.label ||
                                                          commission.term.method
                                                        : "-"}
                                                </td>
                                                <td className="px-6 py-4">
                                                    {commission.term?.term || "-"}
                                                </td>
                                                <td className="px-6 py-4">
                                                    RM
                                                    {commission.term?.amount ||
                                                        ""}
                                                </td>
                                                <td className="px-6 py-4">
                                                    {commission.status}
                                                </td>
                                                {(user.auth.type === "superadmin" || user.auth.type === "admin" || user.auth.type === "manager") && (
                                                    <td className="px-6 py-4">
                                                        <div className="flex space-x-2">
                                                            <button
                                                                onClick={() => {
                                                                    setEditModalState(
                                                                        true
                                                                    );
                                                                    setModalData(
                                                                        commission
                                                                    );
                                                                }}
                                                                className="text-orange-400 hover:text-orange-600"
                                                            >
                                                                <FiEdit />
                                                            </button>
                                                            {user.auth.type === "superadmin" && (
                                                                <button
                                                                    onClick={() =>
                                                                        handleDeleteCommission(
                                                                            commission._id
                                                                        )
                                                                    }
                                                                    className="text-orange-400 hover:text-orange-600"
                                                                >
                                                                    <FiTrash2 />
                                                                </button>
                                                            )}
                                                        </div>
                                                    </td>
                                                )}
                                            </tr>
                                        );
                                    }
                                )
                            ) : (
                                <tr>
                                    <td
                                        colSpan={(user.auth.type === "superadmin" || user.auth.type === "admin" || user.auth.type === "manager") ? "17" : "16"}
                                        className={`px-6 py-4 text-center ${
                                            isDarkMode
                                                ? "text-gray-400"
                                                : "text-gray-500"
                                        }`}
                                    >
                                        {commissionsLoading
                                            ? "Loading..."
                                            : "No commissions found"}
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                    {commissionsData &&
                        commissionsData.fetchCommissions.pagination && (
                            <div
                                className={`px-4 py-3 flex items-center justify-between border-t ${
                                    isDarkMode
                                        ? "border-gray-700"
                                        : "border-gray-200"
                                }`}
                            >
                                <div className="flex-1 flex justify-between items-center">
                                    <div
                                        className={`text-sm ${
                                            isDarkMode
                                                ? "text-gray-300"
                                                : "text-gray-700"
                                        }`}
                                    >
                                        Showing{" "}
                                        <span className="font-medium">
                                            {(paginationState.page - 1) *
                                                paginationState.pageSize +
                                                1}
                                        </span>{" "}
                                        -{" "}
                                        <span className="font-medium">
                                            {Math.min(
                                                paginationState.page *
                                                    paginationState.pageSize,
                                                commissionsData.fetchCommissions
                                                    .pagination.documents
                                            )}
                                        </span>{" "}
                                        of{" "}
                                        <span className="font-medium">
                                            {
                                                commissionsData.fetchCommissions
                                                    .pagination.documents
                                            }
                                        </span>{" "}
                                        results
                                    </div>
                                    <div className="flex space-x-2">
                                        <button
                                            onClick={() =>
                                                setPaginationState((prev) => ({
                                                    ...prev,
                                                    page: 1,
                                                }))
                                            }
                                            disabled={
                                                paginationState.page === 1
                                            }
                                            className={`px-3 py-1 rounded-md text-sm font-medium ${
                                                paginationState.page === 1
                                                    ? isDarkMode
                                                        ? "bg-gray-700 text-gray-500 cursor-not-allowed"
                                                        : "bg-gray-100 text-gray-400 cursor-not-allowed"
                                                    : "bg-orange-400 text-white hover:bg-blue-600"
                                            }`}
                                        >
                                            First
                                        </button>
                                        <button
                                            onClick={() =>
                                                setPaginationState((prev) => ({
                                                    ...prev,
                                                    page: prev.page - 1,
                                                }))
                                            }
                                            disabled={
                                                paginationState.page === 1
                                            }
                                            className={`px-3 py-1 rounded-md text-sm font-medium ${
                                                paginationState.page === 1
                                                    ? isDarkMode
                                                        ? "bg-gray-700 text-gray-500 cursor-not-allowed"
                                                        : "bg-gray-100 text-gray-400 cursor-not-allowed"
                                                    : "bg-orange-400 text-white hover:bg-blue-600"
                                            }`}
                                        >
                                            Previous
                                        </button>
                                        <span
                                            className={`px-3 py-1 ${
                                                isDarkMode
                                                    ? "bg-gray-700 text-gray-300"
                                                    : "bg-gray-100"
                                            } rounded-md text-sm font-medium`}
                                        >
                                            Page {paginationState.page} of{" "}
                                            {
                                                commissionsData.fetchCommissions
                                                    .pagination.totalPages
                                            }
                                        </span>
                                        <button
                                            onClick={() =>
                                                setPaginationState((prev) => ({
                                                    ...prev,
                                                    page: prev.page + 1,
                                                }))
                                            }
                                            disabled={
                                                paginationState.page ===
                                                commissionsData.fetchCommissions
                                                    .pagination.totalPages
                                            }
                                            className={`px-3 py-1 rounded-md text-sm font-medium ${
                                                paginationState.page ===
                                                commissionsData.fetchCommissions
                                                    .pagination.totalPages
                                                    ? isDarkMode
                                                        ? "bg-gray-700 text-gray-500 cursor-not-allowed"
                                                        : "bg-gray-100 text-gray-400 cursor-not-allowed"
                                                    : "bg-orange-400 text-white hover:bg-blue-600"
                                            }`}
                                        >
                                            Next
                                        </button>
                                        <button
                                            onClick={() =>
                                                setPaginationState((prev) => ({
                                                    ...prev,
                                                    page: commissionsData
                                                        .fetchCommissions
                                                        .pagination.totalPages,
                                                }))
                                            }
                                            disabled={
                                                paginationState.page ===
                                                commissionsData.fetchCommissions
                                                    .pagination.totalPages
                                            }
                                            className={`px-3 py-1 rounded-md text-sm font-medium ${
                                                paginationState.page ===
                                                commissionsData.fetchCommissions
                                                    .pagination.totalPages
                                                    ? isDarkMode
                                                        ? "bg-gray-700 text-gray-500 cursor-not-allowed"
                                                        : "bg-gray-100 text-gray-400 cursor-not-allowed"
                                                    : "bg-orange-400 text-white hover:bg-blue-600"
                                            }`}
                                        >
                                            Last
                                        </button>
                                    </div>
                                </div>
                            </div>
                        )}
                    </>
                    )}
                </div>

                {editModalState && (
                    <Modal reset={resetEditModal}>
                        <div className="container h-full mx-auto flex justify-center items-center">
                            <div
                                className={`panel ${
                                    isDarkMode ? "bg-gray-800" : "bg-white"
                                } p-6 rounded-md max-w-5xl w-full`}
                            >
                                <div
                                    className={`mb-4 text-2xl font-bold ${
                                        isDarkMode ? "text-white" : ""
                                    }`}
                                >
                                    Edit Commission
                                </div>
                                <form
                                    onSubmit={handleSubmit(
                                        handleEditCommission
                                    )}
                                >
                                    <div className="mb-4">
                                        <div
                                            className={`my-2 text-sm font-medium ${
                                                isDarkMode
                                                    ? "text-gray-300"
                                                    : "text-lynch"
                                            }`}
                                        >
                                            Status
                                        </div>
                                        <Controller
                                            as={
                                                <Select
                                                    styles={memberSelect}
                                                    isSearchable={false}
                                                />
                                            }
                                            name="status"
                                            control={control}
                                            rules={{ required: true }}
                                            options={statusOptions}
                                            className="mb-2"
                                        />
                                        {errors.status && (
                                            <p className="text-red-400 text-xs">
                                                Status cannot be empty
                                            </p>
                                        )}
                                    </div>

                                    <button
                                        type="submit"
                                        className="bg-blue-400 hover:bg-blue-600 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                                    >
                                        Update Commission
                                    </button>
                                </form>
                            </div>
                        </div>
                    </Modal>
                )}
            </div>
        </div>
    );
};

export default withUser(Commissions);
